export const GET_FBTS = "GET_FBTS"
export const SET_FBTS = "SET_FBTS"
export const GET_FBT_BY_ID = "GET_FBT_BY_ID"
export const SET_FBT = "SET_FBT"
export const DOWNLOAD_FBT_DUMP = "DOWNLOAD_FBT_DUMP"
export const UPDATE_FBT = "UPDATE_FBT"
export const CREATE_FBT = "CREATE_FBT"
export const UPLOAD_FBT_FILE = "UPLOAD_FBT_FILE"
export const SET_FBT_LOADER = "SET_FBT_LOADER"
export const SET_DOWNLOAD_DUMP_LOADER = "SET_DOWNLOAD_DUMP_LOADER"